import React, { useEffect, useState } from 'react';
import Preloader from '../../Components/Preloader';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import { NavLink } from 'react-router-dom';
import Complaint_Policy_Seo from '../../SEO/Complaint_Policy_Seo';
import AOS from 'aos';

function ComplaintPolicy() {
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        // Simulate an asynchronous operation (e.g., fetching data)
        setTimeout(() => {
            setIsLoading(false);
        }, 500); // Simulating a 1-second delay
    }, []);
    useEffect(() => {
        AOS.init({
            duration: 3000,
            easing: 'ease-in-out',
            once: true,
            mirror: false,
        });
    }, []);
    return (
        <div>
            {isLoading ? (
                <Preloader />
            ) : (
                <>
                    <Complaint_Policy_Seo />
                    <Header />
                    {/* Start Page Banner Area */}
                    <div className="page-banner-area position-relative overflow-hidden" style={{ backgroundImage: 'url(assets/images/hero/hero-image-2.svg)' }}>
                        <div className="container">
                            <div className="page-banner-content">
                                <h1>Complaints Policy</h1>
                                <ul>
                                    <li><NavLink to="/">Home</NavLink></li>
                                    <li>Complaints Policy</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* End Page Banner Area */}
                    {/* Complaints Policy section start */}
                    <div className="privacy-policy-area ptb-100">
                        <div className="container">
                            <div className="privacy-policy-content">
                                <div className="information-collection">
                                    <h4>Our complaints policy</h4>
                                    <p className="mb-2">
                                        We are committed to providing a high-quality money transfer service to all our clients. When something goes wrong, we need you to tell us about it. This will help us to improve our standards.
                                    </p>
                                    <p>
                                        If you have a complaint, please contact us with the details.
                                    </p>
                                </div>
                                <div className="information-collection">
                                    <h4>Definitions</h4>
                                    <ul className="features two mt-2">
                                        <li>
                                            By Email: <NavLink to="mailto:info@ifepay.co.uk">info@ifepay.co.uk</NavLink>
                                        </li>
                                        <li>
                                            By Phone: <NavLink to="tel:02030061093">02030061093</NavLink> / <NavLink to="tel:07707337351">07707337351</NavLink>
                                        </li>
                                        <li className="end">
                                            By Post: <NavLink to="https://maps.app.goo.gl/B1eYbFnsuJXh78xj9" target="_blank">Suite 5, Community house, 19 - 21 Eastern Road ,Post code RM13NH, Romford</NavLink>
                                        </li>
                                    </ul>
                                    <p className="mt-2">
                                        We have eight weeks to consider your complaint. If we have not resolved it within this time you may complain to the Financial Ombudsman Service.
                                    </p>
                                </div>
                                <div className="information-collection">
                                    <h4>What will happen next?</h4>
                                    <ul className="features two mt-2">
                                        <li>
                                            We will send you a letter/email acknowledging receipt of your complaint on the same day of receiving it, enclosing a copy of this procedure. If you have complained in person or on call, we will try to resolve and reach the solution the same day.
                                        </li>
                                        <li>
                                            If we are unable to resolve your complaint on the same day then we will further investigate your complaint. This will normally involve finding details of your complaint, reviewing your matter by speaking to the member of staff who acted for you.
                                        </li>
                                        <li>
                                            We will respond to you within 7 days with our Final Response which may be a remedial action.
                                        </li>
                                        <li className="end">
                                            If you are still not satisfied, you can then contact the Financial Ombudsman Service, about your complaint. Normally, you will need to bring a complaint to the Financial Ombudsman Service within six months of receiving a final written response from us about your complaint. For further information, you should contact the Financial Ombudsman Service on:
                                            <ul className="mt-2">
                                                <li>
                                                    Online: <NavLink to="https://www.financial-ombudsman.org.uk/" target="_blank">https://www.financial-ombudsman.org.uk/</NavLink>
                                                </li>
                                                <li>
                                                    Email: <NavLink to="mailto:complaint.info@financial-ombudsman.org.uk">complaint.info@financial-ombudsman.org.uk</NavLink> ,
                                                </li>
                                                <li>
                                                    By post: The Financial Ombudsman Service Exchange Tower, London, E14 9SR
                                                </li>
                                                <li>
                                                    Phone: <NavLink to="tel:08000234567">0800 023 4 567</NavLink> (free), <NavLink to="tel:03001239123">0300 123 9 123</NavLink>, weekdays from 8:00am - 8:00pm (GMT), and on Saturday from 9:00 - 1:00pm (GMT).
                                                </li>
                                            </ul>
                                        </li>
                                        <li>
                                            If you're not in the UK, call <NavLink to="tel:02030061093">02030061093</NavLink> / <NavLink to="tel:07707337351">07707337351</NavLink>.
                                        </li>
                                    </ul>
                                    <p>
                                        FOS will not charge you for making a complaint and if you are not satisfied with the outcome you can still bring legal proceedings. In addition, please note that disputes may also be submitted for online resolution via the European Online Dispute Resolution Platform accessible at: <NavLink to="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</NavLink>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Complaints Policy section end */}
                    {/* Footer Section Here */}
                    <Footer />
                </>
            )}
        </div>
    );
}

export default ComplaintPolicy
